import { render, staticRenderFns } from "./EditAllocations.vue?vue&type=template&id=42341664"
import script from "./EditAllocations.vue?vue&type=script&lang=js"
export * from "./EditAllocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports